import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { isFetchingFeatureFlags } from '@core/selectors/classroom';
import React from 'react';
import DefaultUserBar from './UserBar';
import UserBarResponsive from './UserBarResponsive';
import useCustomZendeskItems from '@app/hooks/useCustomZendeskItems';
import Zendesk from '../Zendesk/Zendesk';
import Intercom from '../Intercom/Intercom';

const UserBar = (props) => {
  const { showCustomItems } = useCustomZendeskItems();

  const { webAppFtResponsiveNavBar20254 } = useFlags();

  const fetchingFeatureFlags = useSelector(isFetchingFeatureFlags);

  if (fetchingFeatureFlags) {
    return null;
  }

  return (
    <>
      {webAppFtResponsiveNavBar20254 ? (
        <UserBarResponsive {...props} />
      ) : (
        <DefaultUserBar {...props} />
      )}

      <div style={{ visibility: 'hidden' }}>
        {!window['Cypress'] && (
          <>
            <Zendesk suppressContactForm={showCustomItems} />
            <Intercom />
          </>
        )}
      </div>
    </>
  );
};

export default UserBar;
